
// region JS Imports

// region External Modules
import u from "umbrellajs"
// endregion External Modules

// Private Modules
import ImageLazyLoading from "widgets/image_lazyloading"
import ListingsCarousel from "concepts/listings/carousel"
// Private Modules

// region Public Components
// endregion Public Components

// region Private Components
import WithToggle from "concepts/listings/pictures_and_map_browser/with_toggle/index"
import {
  init as building_follow_button_init,
} from "concepts/buildings/building_follow_button/index"

import {
  init as neighbourhood_follow_button_init,
} from "concepts/neighbourhoods/neighbourhood_follow_button/index"

import {
  init as listing_shortlist_button_init,
} from "concepts/listings/listing_shortlist_button/index"

import * as ListerSpeakingLanguagesBadge from "concepts/listings/feature/lister_speaking_languages/badge_with_popover"
// endregion Private Components

// endregion JS Imports


const CELL_CLASS_NAME = "cell--listings--row--for-searching--default"
const CELL_INITIALIZED_CLASS_NAME = `${CELL_CLASS_NAME}--js-spacious-initialized`

const IMAGE_CELL_CLASS_NAME = "cell--listings--row--for-searching--default__section-listing-image"


const init = () => {
  ImageLazyLoading.default_lazyload_instance().update()

  u(`.${CELL_CLASS_NAME}`).each((el) => {
    const $el = u(el)

    if (el.classList.contains(CELL_INITIALIZED_CLASS_NAME)) { return }
    el.classList.add(CELL_INITIALIZED_CLASS_NAME)

    $el.on("click", (e) => {
      const $this = u(e.target as HTMLElement)

      // If user clicks on a non-link, go to full listing page
      if ($this.closest(`.${IMAGE_CELL_CLASS_NAME}`).length === 0 && $this.closest("a").length === 0){
        window.open($el.data("full-listing-page-path"), "_blank")
      }
    })
  })
  WithToggle.init()
  ListingsCarousel.init()
  ListerSpeakingLanguagesBadge.initAllMatchingElements()
  building_follow_button_init()
  neighbourhood_follow_button_init()
  listing_shortlist_button_init().done()
}


export default {init}
